import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { Document } from 'modules/documents/hooks/documents/useGetDocuments'
import { isPendingToFill, isTemplate } from 'modules/documents/lib/Documents'

import EmployeesTooltip from './EmployeesTooltip'

interface Props {
  fileName: string
  employeeNames: string[]
  employeeCount?: number
  requestEsignature: boolean
  signeesCount: number
  onClose: () => void
  onConfirm: () => void
  document: Document
}

const AssignConfirmationModal = ({
  fileName,
  employeeNames,
  employeeCount,
  requestEsignature,
  signeesCount,
  onClose,
  onConfirm,
  document,
}: Props) => {
  const title = i18n.t('documents.upload.confirmation.title')
  const effectiveCount = employeeCount ?? employeeNames.length
  const numberOfEmployees = i18n.tp('documents.upload.confirmation.employees', {
    count: effectiveCount,
  })
  const description = i18n.t('documents.upload.confirmation.description', {
    fileName: fileName,
  })
  const signeesDescription = i18n.tp('documents.upload.confirmation.esignature.signees', {
    count: effectiveCount,
  })
  const additionalSigneesDescription = i18n.tp(
    'documents.upload.confirmation.esignature.additional_signees',
    {
      count: signeesCount,
    }
  )
  const templateWarningDescription = isPendingToFill(document)
    ? i18n.t('documents.upload.confirmation.document_templates.fillable')
    : i18n.t('documents.upload.confirmation.document_templates.empty_variables')
  const submitLabel = `${i18n.t('documents.upload.confirmation.submit')} ${numberOfEmployees}`
  const cancelLabel = i18n.t('documents.upload.confirmation.cancel')
  const ifAdditionalSignees = Boolean(signeesCount > 0)

  return (
    <Modal
      title={title}
      description
      illustration="file-upload"
      onClose={onClose}
      onSubmit={onConfirm}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {cancelLabel}
          </Button>
          <Button submit>{submitLabel}</Button>
        </>
      }
    >
      <EmployeesTooltip
        description={description}
        tooltipLabel={numberOfEmployees}
        employeeNames={employeeNames}
      />

      {requestEsignature && (
        <Box paddingTop="s24">
          <Box
            paddingX="s24"
            paddingY="s16"
            background="grey200"
            borderRadius={{
              all: 'abs008',
            }}
          >
            <Text.Normal>{signeesDescription}</Text.Normal>
            {ifAdditionalSignees && <Text.Normal>{additionalSigneesDescription}</Text.Normal>}
          </Box>
        </Box>
      )}

      {isTemplate(document) && (
        <Box paddingTop="s24">
          <Box
            paddingX="s24"
            paddingY="s16"
            background="champagne400"
            borderRadius={{
              all: 'abs008',
            }}
          >
            <Text.Normal>{templateWarningDescription}</Text.Normal>
          </Box>
        </Box>
      )}
    </Modal>
  )
}

export default AssignConfirmationModal
